import React from 'react';
import Markdown from '../../Markdown';
import { FormGroup, FormControlLabel } from './MultiSelectFieldView';
import Checkbox from '@material-ui/core/Checkbox';
import styled from 'styled-components/macro';
import Colors from '../../../internal-components/Colors';
import { Tooltip } from '@material-ui/core';

const Lable = styled.label`
  display: flex;
  align-items: center;

  &:after {
    content: '${({ required }) => (required ? ' *' : '')}';
    color: ${Colors.OT_RED};
    font-size: 20px;
    font-weight: 600;
    white-space: pre;
  }
`;

const ConfirmationBoxView = props => {
  // const titleLines = props.title.trim().split('\n');

  return (
    <FormGroup>
      <Tooltip title={props.tooltip || ''} placement="left" arrow>
        <FormControlLabel
          control={
            <Checkbox
              disabled={props.readOnly}
              checked={props.value}
              onChange={props.onChecked}
              name={props.title}
              color="primary"
              data-testid={`multiselect-${props.internalId}`}
            />
          }
          label={<Markdown content={props.checkboxText.trim()} />}
        />
      </Tooltip>
    </FormGroup>
  );
};

export default ConfirmationBoxView;
